import React, { useState } from "react";
// import { Table } from "antd";
// import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
// import { Icon } from "@iconify/react";
import { Select } from "antd";
import MultilineChart from "../../components/dashboard/multilineChart";
import DelTableRowModal from "../../modals/delTableRowModal";
import { useTranslation } from "react-i18next";

const data = [
  {
    key: "1",
    activity: "New user",
    description: "John Doe just joined and bought a new plan",
    date: "Mon Oct 7, 2024 11:30 am",
  },
  {
    key: "2",
    activity: "New user",
    description: "Jane Smith upgraded to a premium plan",
    date: "Tue Oct 8, 2024 10:15 am",
  },
  {
    key: "3",
    activity: "Payment",
    description: "Emily Davis made a payment for the basic plan",
    date: "Wed Oct 9, 2024 09:20 am",
  },
];

const Home = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const months = ["January", "March", "May", "July", "August", "October", "November"];
  // const navigate = useNavigate();
  const [isdelModalOpen, setIsdelModalOpen] = useState(false);
  // const onDelClick = () => {
  //   setIsdelModalOpen(true);
  // };

  // const columns = [
  //   {
  //     title: "Activity",
  //     dataIndex: "activity",
  //     key: "activity",
  //     render: (text) => <p className="text-black small  font-medium">{text}</p>,
  //   },
  //   {
  //     title: "Description",
  //     dataIndex: "description",
  //     key: "description",
  //     render: (description) => <p className="text-black small  font-medium">{description}</p>,
  //   },
  //   {
  //     title: "Date",
  //     dataIndex: "date",
  //     key: "date",
  //     render: (date) => <p className="text-black small  font-medium">{date}</p>,
  //   },
  //   {
  //     title: "Actions",
  //     key: "actions",
  //     render: () => (
  //       <div className="flex gap-[8px]  items-center">
  //         <button
  //           className="bg-[#D3EFF4] text-secondary rounded-[47px] px-[15px] py-[5px] small font-poppins cursor-pointer"
  //           onClick={() => navigate("/user-details/chat-history")}
  //         >
  //           Details
  //         </button>
  //         <img
  //           src="../../assets/icons/del.png"
  //           alt=""
  //           className="cursor-pointer"
  //           onClick={onDelClick}
  //         />
  //       </div>
  //     ),
  //   },
  // ];
  return (
    <>
      <div className="dashboard-main flex flex-col gap-[31px] pt-[30px]">
        <div className="top flex gap-[20px] sm-s:flex-col">
          <div className="cases-div flex flex-col gap-[20px] sm-s:max-w-[100%] max-w-[25%] w-full">
            <div class=" flex flex-col items-center justify-center h-full pt-[18px] pb-[21px] px-[10px] gap-[6px] rounded-[16px] bg-[rgba(255,255,255,0.80)] backdrop-blur-[53px]">
              <p className="text-blue font-semibold large">{t("adminDashboard.home.totalUsers")}</p>
              <h4 className="esmall font-semibold text-blue">
                1,0<span className="text-secondary">40</span>
              </h4>
            </div>
            <div class="flex flex-col items-center justify-center h-full pt-[18px] pb-[21px] px-[10px] gap-[6px] rounded-[16px] bg-[rgba(255,255,255,0.80)] backdrop-blur-[53px]">
              <p className="text-blue font-semibold large">{t("adminDashboard.home.totalCases")}</p>
              <h4 className="esmall font-semibold text-blue">
                1,0<span className="text-secondary">40</span>
              </h4>
            </div>
            <div class="flex flex-col items-center justify-center h-full pt-[18px] pb-[21px] px-[10px] gap-[6px] rounded-[16px] bg-[rgba(255,255,255,0.80)] backdrop-blur-[53px]">
              <p className="text-blue font-semibold large">
                {t("adminDashboard.home.activePlans")}
              </p>
              <h4 className="esmall font-semibold text-blue">
                1,0<span className="text-secondary">40</span>
              </h4>
            </div>
          </div>
          <div className="chart-div flex max-w-[100%] w-full flex-col gap-[23px] drop-shadow-md rounded-[21px] px-[50px] max-sm:px-[20px] py-[15px] border-[rgba(255,255,255,0.28)] bg-[#F4F4F4] shadow-[0px_39.919px_73.47px_rgba(191,191,191,0.32)]">
            <div className="flex  flex-col gap-[10px]">
              <div className="performance flex justify-between items-center">
                <p className="text-blue font-semibold large">
                  {t("adminDashboard.home.plansUsageByTheTime")}
                </p>
                <Select placeholder="Year" style={{ width: 135 }} className="graph-dropdown">
                  {months.map((month, index) => (
                    <Option key={index} value={month}>
                      {month}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="flex gap-[16px]">
                <div className="flex gap-[6px] items-center">
                  <span className="w-[17px] h-[17px] bg-[#34B3F1] rounded-[4px]"></span>
                  <p className="text-[#8D9092] ">{t("adminDashboard.home.basic")}</p>
                </div>
                <div className="flex gap-[6px] items-center">
                  <span className="w-[17px] h-[17px] bg-[#292D30] rounded-[4px]"></span>
                  <p className="text-[#8D9092] ">{t("adminDashboard.home.premium")}</p>
                </div>
                <div className="flex gap-[6px] items-center">
                  <span className="w-[17px] h-[17px] bg-[#143A62] rounded-[4px]"></span>
                  <p className="text-[#8D9092] ">{t("adminDashboard.home.unlimited")}</p>
                </div>
              </div>
            </div>

            <MultilineChart />
          </div>
        </div>
        {/* <div className="flex flex-col ">
          <div className="p-[25px] bg-white rounded-t-[20px] max-sm:p-[15px]">
            <h6 className="font-semibold">{t("adminDashboard.home.recentActivities")}</h6>
          </div>

          <Table
            columns={columns}
            dataSource={data}
            pagination={{
              position: ["bottomCenter"],
              pageSize: 6,
              itemRender: (current, type, originalElement) => {
                if (type === "prev") {
                  return (
                    <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                      <Icon icon="ep:arrow-left-bold" color="#143A62" />
                    </div>
                  );
                }
                if (type === "next") {
                  return (
                    <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                      <Icon icon="ep:arrow-right-bold" color="#143A62" />
                    </div>
                  );
                }
                return originalElement;
              },
              showSizeChanger: false,
              className: "custom-pagination",
            }}
            className="w-full admin-dashboardTables"
            scroll={{ x: "1000px" }}
          />
        </div> */}
      </div>
      <DelTableRowModal isdelModalOpen={isdelModalOpen} setIsdelModalOpen={setIsdelModalOpen} />
    </>
  );
};

export default Home;
